import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, UrlTree } from '@angular/router';
import { first } from 'rxjs';
import { BadgeData } from 'src/app/models/badge.model';
import { ScrAuthenticationService } from 'src/app/services/authentication.service';
import { CacheService } from 'src/app/services/cache.service';
import { BADGECOUNTS } from 'src/app/shared/constants';
import { ScrAuthorizationService } from '../../services/authorization.service';
import { ScrBaseComponent } from '../base.component';
import { BadgeService } from 'src/app/services/badge.service';
import { ScrEnvironment } from 'src/environments/environment';
import { MicrostrategyService } from 'src/app/services/microstrategy.service';
import { AccountService, ConfigService } from 'src/app/services';
import { ShortCodesRole } from '../../models/constants';

@Component({
  selector: 'app-navigation-sidebar',
  templateUrl: './navigation-sidebar.component.html',
  styleUrls: ['./navigation-sidebar.component.scss']
})
export class NavigationSidebarComponent extends ScrBaseComponent implements OnInit {

  CognitoGroup = ShortCodesRole;

  public unreadmessages?: number;
  public orderCount?: number;
  public shortCodeCount?: number;
  public partnerCount?: number;
  public activePath?: string;
  public showLinkedAccount = false;
  public brandsEnabled = false;

  constructor(
    private accountService: AccountService,
    private authorizationService: ScrAuthorizationService,
    private authService: ScrAuthenticationService,
    private environment: ScrEnvironment,
    private microstrategyService: MicrostrategyService,
    private badgeService: BadgeService,
    private router: Router,
    private cacheService: CacheService,
    private configService: ConfigService) {
    super();
  }

  ngOnInit(): void {

    // initialize first.
    this.update(this.router.parseUrl(this.router.url));

    // subscribe for changes.
    this.subscriptions.push(this.router.events.subscribe({
      next: (ev) => {
        if (ev instanceof NavigationEnd) {
          this.update(this.router.parseUrl(ev.url));
        }
      }
    }));
    
    this.subscriptions.push(this.configService.getConfig().subscribe(cfg => {
      this.brandsEnabled = cfg.brandsEnabled;
    }));

    this.updateLinkedAccounts();

    if (!this.environment.servicedesk) {
      this.fetchBadgeCounts();

      this.subscriptions.push(this.cacheService.subscribe<BadgeData>(BADGECOUNTS).subscribe(badgecounts => {
        //this.log.debug('cache subscribe gave me ' + JSON.stringify(badgecounts));
        if (badgecounts) {
          this.unreadmessages = badgecounts.unreadMessageCount;
          this.orderCount = badgecounts.orderCount;
          this.shortCodeCount = badgecounts.shortCodeCount;
          this.partnerCount = badgecounts.partnerCount;
        }
      }));
    }

    this.subscriptions.push(this.authService.authStateUpdated.subscribe(() => {
      //console.debug('navbar auth state updated.  ' + JSON.stringify(ase));
      this.updateLinkedAccounts(true);
    }));
  }

  private updateLinkedAccounts(clearcache = false) {
    if (this.authService.isUserSignedIn()) {
      this.accountService.getAccount(clearcache, false).pipe(first()).subscribe(rsp => {
        this.authorizationService.hasRole(ShortCodesRole.RegistrantAdmin).pipe(first()).subscribe(hasRole => {
          this.showLinkedAccount = (rsp.account.linkedAccountEnabled ?? false) && hasRole;
        });
      });
    }
  }

  private fetchBadgeCounts() {
    this.authService.userIsSignedIn().then(isSignedIn => {
      if (isSignedIn) {
        this.badgeService.getBadges(false).subscribe(data => {
          this.unreadmessages = data?.unreadMessageCount;
          this.shortCodeCount = data?.shortCodeCount;
          this.orderCount = data?.orderCount;
          this.partnerCount = data?.partnerCount;
          return false; // no success message
        });
      }
    });
  }

  private setActiveChild(path?: string): void {
    this.activePath = path;
  }

  /**
   * Update the active child tab so we can highlight the item in the nav.
   * @param tree - route tree.
   */
  private update(tree: UrlTree): void {
    Object.values(tree.root.children).forEach(sg => {
      if (sg.children) {
        const child = sg.children['navbar-tab'];
        if (child) {
          if (child.segments && child.segments.length > 0) {
            this.setActiveChild(child.segments[0].path);
          }
          else {
            this.setActiveChild();
          }
        }
      }
    });
  }

  public launchMicrostrategyReports() {
    this.microstrategyService.launchMicrostrategyBi().then(msgs => {
      if (msgs) {
        this.processMessages({ status: '', messages: msgs });
      }
    })
      .catch(err => {
        this.doHttpError(err);
      });
  }
}
